import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EventService } from "../service/event.service";
import { Router } from "@angular/router";
import { FormBuilder, Validators, FormGroup, FormArray } from "@angular/forms";
import { MessageService } from "primeng/api";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { environment } from "../../../environments/environment";
import { SelectItem } from "primeng/api";
import { FormControl } from "@angular/forms";
import * as moment from "moment";
import { DatePipe, formatDate } from "@angular/common";
import { Event } from "../admin-interfaces";
import { ConfirmationService } from "primeng/api";
import { MenuItem } from "primeng/api";
import { IssoUtilService } from "../../services/isso-util.service";

@Component({
  selector: "app-event",
  templateUrl: "./event.component.html",
  styleUrls: ["./event.component.css"],
  providers: [MessageService, ConfirmationService, DatePipe],
})
export class EventComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  text2: string;
  zoneOptions: SelectItem[];
  yesNoOptions: SelectItem[];
  options: SelectItem[];
  checked1: boolean = true;
  es: any;
  error: string;
  errormessage: boolean;
  submitted = false;
  public eventForm: FormGroup;
  event_enabled: FormGroup;
  eventServiceData: any;
  checkEvent_stats: boolean;
  totalRecords: number;
  disable = false;
  display: boolean = false;
  checked2: boolean = true;
  eventInfo: Event[];
  actions: string;
  control: FormControl;
  items: MenuItem[];
  items1: MenuItem[];
  items2: MenuItem[];
  activeItem: MenuItem;
  isUpcomingEvent: boolean = false;
  currentEvent: boolean = true;
  neeText: any;
  minDate: Date;
  maxDate: Date;
  endDate: Date;
  subViewTitle: string;
  today: string;
  startDate: any;
  endMinDate: any;
  showspinner: boolean;
  mapEvent: boolean;
  selectedYear: string;
  yearOptions: SelectItem[];
  yearvalue: number;
  eventYear: string;
  manageReport: boolean;
  zoneValue: any;
  isReadonly = true;
  isExtraTabRequired: boolean = false;
  //eventZoneVal: [];

  public form: FormGroup;
  eventZoneVal: any[];
  eventType: string;
  extraTabRequired: string;
  /** One text control per question this event asks each student. */
  extraFields: FormArray;
  teamEventReport: boolean;
  makeActiveEvent: boolean;
  schoolYearRange: string;

  //eventZoneVal: void;
  // eventZoneVal: string;
  constructor(
    public datepipe: DatePipe,
    private confirmation: ConfirmationService,
    private eventService: EventService,
    private messageService: MessageService,
    private issoUtilService: IssoUtilService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.minDate = new Date();
    this.maxDate = new Date();
    this.isUpcomingEvent = false;
    this.initialiseForm();
    this.getEventData();
    this.seCurrenttDate();
    this.loadInitialData();
  }
  loadInitialData() {
    this.yearOptions = this.issoUtilService.setYear();
    ``;
    const today = new Date();
    const currentMonth = today.getMonth() + 1; // getMonth() is zero-based

    let startYear: number;
    let endYear: number;

    if (currentMonth >= 6) {
      // June or later: school year is current year - next year
      startYear = today.getFullYear();
      endYear = startYear + 1;
    } else {
      // Before June: school year is previous year - current year
      endYear = today.getFullYear();
      startYear = endYear - 1;
    }

    this.schoolYearRange = `${startYear}:${endYear}`;
  }
  resetform() {
    this.eventForm.reset();
  }
  patchForm() {
    this.eventForm.patchValue({
      eventZone: [
        { name: "NORTH", code: "NORTH" },
        { name: "EAST", code: "EAST" },
      ],
    });
  }
  onyeareChange(event) {
    this.yearvalue = event.value;
    this.eventService.getEventByYear(this.yearvalue).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response !== "") {
          this.showspinner = false;
          this.eventServiceData = response;
          this.eventInfo = this.eventServiceData;
        } else {
        }
      },
      (error) => {
        //this.errorAlert =true;
      }
    );
  }
  /**
   * Stored as one comma-separated string, so a label may not contain a comma.
   * Rejected in the input rather than escaped - every other reader splits on it.
   */
  static readonly LABEL_PATTERN = /^[^,]+$/;

  get extraFieldControls(): FormControl[] {
    return this.extraFields
      ? (this.extraFields.controls as FormControl[])
      : [];
  }

  addExtraField(value: string = "") {
    this.extraFields.push(
      this.fb.control(value, [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(EventComponent.LABEL_PATTERN),
      ])
    );
  }

  removeExtraField(i: number) {
    this.extraFields.removeAt(i);
  }

  /** Rebuild the rows from a stored "a, b, c". */
  setExtraFields(csv: string) {
    while (this.extraFields.length) this.extraFields.removeAt(0);
    (csv || "")
      .split(",")
      .map((v) => v.trim())
      .filter((v, i, a) => v !== "" && a.indexOf(v) === i)
      .forEach((v) => this.addExtraField(v));
  }

  /** What goes to the server. Blank and duplicate rows drop out. */
  extraFieldsCsv(): string {
    return this.extraFields.controls
      .map((c) => String(c.value || "").trim())
      .filter((v, i, a) => v !== "" && a.indexOf(v) === i)
      .join(",");
  }

  onKitChange(checked: boolean) {
    this.isExtraTabRequired = checked;
    this.extraTabRequired = checked ? "Yes" : "No";
    this.eventForm.patchValue({ extraTabRequired: this.extraTabRequired });
  }
  seCurrenttDate() {
    const now = new Date();
    this.today = now.toISOString();
  }

  /**
   * Which events the list shows.
   *
   * Active and Inactive are worked on at different times - one is the season being
   * run, the other is history and switched-off entries - so they get their own tabs
   * instead of being interleaved across ten pages.
   */
  tab: 'active' | 'inactive' = 'active';

  /** The single definition of Active; the cards' status badge reads this too. */
  /**
   * The stored flag - what the switch shows, what it writes, which tab the
   * event sits in, and what the label beside it says. One value, read back
   * everywhere, so the switch, the label and the tab can never disagree.
   *
   * The switch used to render from an isActive() that also folded in
   * hasEnded(). A past event with the flag still on drew as OFF while the
   * server held '1', so the first click wrote '1'->'0' and changed nothing on
   * screen, and no later click could turn it on. Whether the event has ended
   * is a separate fact, reported in the note below the switch.
   */
  registrationFlagOn(event: any): boolean {
    if (this.registrationFrozen(event)) { return false; }
    return !!event && String(event.event_status) === '1';
  }

  /**
   * The first day is over, so registration is frozen for good.
   *
   * ISSO was forgetting to close events and squads stayed editable while the
   * event was being run. The date decides it now; the switch is read-only from
   * here and the server refuses to reopen it either.
   */
  registrationFrozen(event: any): boolean {
    const start = event && event.startDate;
    if (!start) { return false; }
    const first = new Date(start);
    first.setHours(23, 59, 59, 999);
    return first.getTime() < Date.now();
  }

  /** The label beside the switch. Says what the switch says, nothing else. */
  registrationText(event: any): string {
    return this.registrationFlagOn(event) ? 'Open for registration' : 'Closed for registration';
  }

  /**
   * Thumbnail for a card - the uploaded image, or the sport's default artwork.
   *
   * The backend resolves which (displayImageUrl), so the sport -> file mapping
   * lives in one place rather than being restated here. The sport artwork is
   * served by the school portal, which is a different origin from the admin,
   * so those paths are absolute against portalUrl; an uploaded /upload/... path
   * is the backend's and resolves the usual way.
   */
  eventThumb(event: any): string {
    const src = String((event && (event.displayImageUrl || event.imageUrl)) || '');
    if (!src) { return ''; }
    if (/^https?:\/\//.test(src)) { return src; }
    if (src.indexOf('/sports/') === 0) {
      return String(environment.portalUrl || '').replace(/\/$/, '') + src;
    }
    return this.assetUrl(src);
  }

  /** A broken image should leave the card tidy, not show a torn-picture glyph. */
  onThumbError(ev: any): void {
    if (ev && ev.target) { ev.target.style.display = 'none'; }
  }

  /** 'National' | 'Regional'. The feed sends either the code or the word. */
  eventTypeLabel(event: any): string {
    const t = String((event && event.eventType) || '');
    if (t === '1' || t === 'National') { return 'National'; }
    if (t === '2' || t === 'Regional') { return 'Regional'; }
    return '';
  }

  /**
   * Start and end as one range - "3 - 8 Sep 2026" - collapsing whatever the two
   * dates share. Two separate rows reading "3 September , 2026" and
   * "8 September , 2026" (the stray space is the old format string) spent two
   * lines of the card restating the same month and year.
   */
  eventDates(event: any): string {
    const start = event && event.startDate ? new Date(event.startDate) : null;
    if (!start || isNaN(start.getTime())) { return '-'; }
    const end = event && event.endDate ? new Date(event.endDate) : null;
    const f = (d: Date, pattern: string) => formatDate(d, pattern, 'en-US');
    if (!end || isNaN(end.getTime()) || start.getTime() === end.getTime()) {
      return f(start, 'd MMM y');
    }
    if (start.getFullYear() === end.getFullYear()) {
      return start.getMonth() === end.getMonth()
        ? f(start, 'd') + ' - ' + f(end, 'd MMM y')
        : f(start, 'd MMM') + ' - ' + f(end, 'd MMM y');
    }
    return f(start, 'd MMM y') + ' - ' + f(end, 'd MMM y');
  }

  get visibleEvents(): any[] {
    const rows: any[] = (this.eventInfo as any[]) || [];
    return rows.filter(e => (this.tab === 'active' ? this.registrationFlagOn(e) : !this.registrationFlagOn(e)));
  }

  countFor(which: 'active' | 'inactive'): number {
    const rows: any[] = (this.eventInfo as any[]) || [];
    return rows.filter(e => (which === 'active' ? this.registrationFlagOn(e) : !this.registrationFlagOn(e))).length;
  }

  setTab(t: 'active' | 'inactive') { this.tab = t; }

  // An event stays Active for its whole run, not just until it starts. It goes
  // Inactive the day after it ends, or when an admin switches it off.
  hasEnded(event: any): boolean {
    const last = event.endDate || event.startDate;
    if (!last) { return false; }
    const end = new Date(last);
    end.setHours(23, 59, 59, 999);
    return end.getTime() < Date.now();
  }
  changeEndDate(event: any) {
    var date = new Date(event);
    var newdate = new Date(date);
    newdate.setDate(newdate.getDate() + 1);
    var dd = newdate.getDate();
    var mm = newdate.getMonth() + 1;
    var y = newdate.getFullYear();
    var someFormattedDate = mm + "/" + dd + "/" + y;
    this.endMinDate = new Date(someFormattedDate);
  }

  zoneChange(event) {
    this.zoneValue = event.value;
  }
  getEventData() {
    this.showspinner = true;
    const month = new Date().getMonth();
    const year = new Date().getFullYear();

    if (month >= 5) {
      this.eventYear = year + "-" + (year + 1);
    } else {
      this.eventYear = year - 1 + "-" + year;
    }
    this.selectedYear = this.eventYear;
    this.eventService.getEventByYear(this.eventYear).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response !== "") {
          this.showspinner = false;
          this.eventServiceData = response;
          this.eventInfo = this.eventServiceData;
        }
      },
      (error) => {
        //this.errorAlert =true;
      }
    );
  }

  initialiseForm() {
    this.zoneOptions = this.issoUtilService.setEventZone();
    this.event_enabled = this.fb.group({
      checkEvent_stats: [""],
      checked2: [""],
    });
    this.extraFields = this.fb.array([]);
    this.eventForm = this.fb.group({
      eventId: [""],
      eventName: ["", Validators.required],
      registrationCharge: ["", Validators.required],
      eventStartDate: ["", Validators.required],
      eventEndDate: ["", Validators.required],
      reportingDate: [""],
      eventLocation: ["", Validators.required],
      eventType: ["", Validators.required],
      eventZone: ["", Validators.required],
      eventDesc: ["", Validators.required],
      eventNote: ["", Validators.required],
      certificateHeaderContent: ["", Validators.required],
      certificateMainContent: ["", Validators.required],
      extraTabRequired: [""],
      extraTabValues: [""],
      contactPhone: [""],
      contactEmail: [""],
    });
    this.options = [
      { label: "Please select", value: "" },
      { label: "National", value: "National" },
      { label: "Regional", value: "Regional" },
    ];
    this.yesNoOptions = this.issoUtilService.setYesNo();
    this.control = new FormControl(this.options[2].value);
    this.extraTabRequired == "1";
  }
  showDialog() {
    this.display = true;
  }
  testFun() {}
  addNewEvent(event: Event, eventInfo: Event, type: any) {
    if (type == "edit") {
      this.eventType = eventInfo.eventType;

      if (eventInfo.startDate > this.today) {
        this.isReadonly = false;
      } else {
        this.isReadonly = true;
      }

      const existingData = {
        eventZone: (eventInfo.eventZone || "").split(",").filter((z) => z),
      };
      this.eventZoneVal = existingData.eventZone;
      this.zoneValue = existingData.eventZone;
      this.eventForm.patchValue({
        eventId: eventInfo.eventId,
        eventName: eventInfo.eventName,
        registrationCharge: eventInfo.price,
        eventStartDate: new Date(eventInfo.startDate),
        eventEndDate: new Date(eventInfo.endDate),
        reportingDate: eventInfo.reportingDate
          ? new Date(eventInfo.reportingDate)
          : "",
        eventLocation: eventInfo.location,
        eventType: eventInfo.eventType,
        eventZone: existingData.eventZone,
        eventDesc: eventInfo.description,
        eventNote: eventInfo.note,
        certificateHeaderContent: eventInfo.certifiacteHeaderContent,
        certificateMainContent: eventInfo.certifiacteMainContent,
        extraTabRequired: eventInfo.extraTabRequired,
        extraTabValues: eventInfo.extraTabValues,
        contactPhone: eventInfo.contactPhone,
        contactEmail: eventInfo.contactEmail,
      });
      this.resetEventImage(eventInfo.imageUrl || eventInfo.eventImage);
      // keep the ngModel-backed dropdowns in sync with the patched controls
      this.extraTabRequired = eventInfo.extraTabRequired;
      this.isExtraTabRequired = eventInfo.extraTabRequired === "Yes";
      this.setExtraFields(eventInfo.extraTabValues);
      this.subViewTitle = "Edit Event";
    } else {
      //if (eventInfo.startDate > this.today) {
      this.isReadonly = false;
      // }

      this.eventForm.setValue({
        eventId: "",
        eventName: "",
        registrationCharge: "",
        eventType: " ",
        eventZone: " ",
        eventStartDate: " ",
        eventEndDate: " ",
        reportingDate: "",
        eventLocation: " ",
        eventDesc: " ",
        eventNote: "",
        certificateHeaderContent:
          "ISSO NATIONAL GAMES " + this.issoUtilService.getAcademicYear(),
        certificateMainContent:
          "ISSO NATIONAL GAMES " + this.issoUtilService.getAcademicYear(),
        extraTabRequired: "Yes",
        extraTabValues: "",
        contactPhone: "",
        contactEmail: "",
      });
      this.extraTabRequired = "Yes";
      this.isExtraTabRequired = true;
      this.setExtraFields("");
      this.eventZoneVal = [];
      this.zoneValue = "";
      this.eventType = "";
      this.resetEventImage();
      this.subViewTitle = "Add New Event";
    }
    this.display = true;
  }

  hideExtraView() {
    this.display = false;
    this.resetEventImage();
  }

  /**
   * Switching an event on or off is confirmed first.
   *
   * The badge on each card doubles as the toggle, so it sits right where an admin
   * clicks to READ the status - and the click took effect immediately. Activating
   * opens the event to every school at once; deactivating pulls it out from under
   * schools mid-entry. Neither should happen on a misplaced click.
   */
  confirmChangeEventStatus(eventData: Event) {
    if (this.registrationFrozen(eventData)) { return; }
    const activating = String(eventData.event_status) !== '1';
    const name = (eventData && eventData.eventName) || 'this event';

    // The switch decides registration, not visibility, and closing it no longer
    // stops payment - a school that already entered its squad can still pay
    // until the first day. The wording has to say that, or ISSO closes an event
    // believing it has cut the money off too.
    this.confirmation.confirm({
      key: 'confirm-event-status',
      icon: activating ? 'pi pi-info-circle' : 'pi pi-exclamation-triangle',
      header: activating ? 'Open registration' : 'Close registration',
      message: activating
        ? (this.hasEnded(eventData)
            ? 'Turn the registration flag back on for "' + name + '"? The event is already '
              + 'over, so schools still cannot enter students - this only changes the flag.'
            : 'Open registration for "' + name + '"? Schools will be able to enter students.')
        : 'Close registration for "' + name + '"? Schools can no longer add or remove students. '
          + 'They can still pay for students already entered, until the first day of the event.',
      acceptLabel: activating ? 'Yes, open registration' : 'Yes, close registration',
      rejectLabel: 'Cancel',
      accept: () => { this.changeEventStatus(eventData); },
    });
  }

  changeEventStatus(eventData: Event) {
    const eventStatus = eventData.event_status;
    const eventId = eventData.eventId;
    const formData = new FormData();
    if (eventStatus == "1") {
      formData.append("event_status", "0");
    } else {
      formData.append("event_status", "1");
    }

    // The toast said "Event Data Updated Successfully" whichever way the switch
    // went, so nothing on screen confirmed what had just changed.
    const nowOpen = eventStatus != "1";
    this.eventService.changeEventStatus(eventId, formData).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        void res;
        this.messageService.add({
          key: "custom",
          severity: "success",
          summary: nowOpen ? "Registration opened" : "Registration closed",
          detail: nowOpen
            ? "Schools can now enter students for this event."
            : "Schools can still pay for students already entered, until the first day.",
        });
        this.display = false;
        this.getEventData();
      },
      (error) => (this.error = error)
    );
  }
  eventImageFile: File | null = null;
  eventImagePreview: string | null = null;
  eventImageError = '';

  // The event card renders the image at 357x210, so the crop is locked to that
  // ratio and exported at 2x. Hand-rolled rather than pulling a cropper library
  // into Angular 8, whose peer deps are already fragile.
  private readonly CROP_W = 357;
  private readonly CROP_H = 210;
  private readonly OUT_SCALE = 2;

  cropOpen = false;
  cropSrc: string | null = null;
  cropZoom = 1;
  cropX = 0;
  cropY = 0;
  private cropImg: HTMLImageElement | null = null;
  private dragging = false;
  private dragStartX = 0;
  private dragStartY = 0;
  private originalName = 'event.jpg';

  /**
   * Clears the picked/cropped image and shows whatever the event already has.
   * Without this the file from the previously edited event stays on the
   * component and is re-uploaded on the next save, so one image ends up on
   * every event.
   */
  resetEventImage(existingUrl?: string) {
    this.eventImageFile = null;
    this.eventImageError = '';
    this.cropOpen = false;
    this.cropSrc = null;
    this.cropImg = null;
    this.originalName = 'event.jpg';
    this.eventImagePreview = existingUrl ? this.assetUrl(existingUrl) : null;
  }

  /** Uploads are served from the API host, not the Angular one. */
  assetUrl(p: string): string {
    if (!p) { return ''; }
    if (/^https?:\/\//.test(p)) { return p; }
    return environment.baseUrl.replace(/api\/?$/, '').replace(/\/$/, '') + p;
  }

  onEventImagePick(e: any) {
    const file: File = e.target.files && e.target.files[0];
    this.eventImageError = '';
    this.eventImageFile = null;
    this.eventImagePreview = null;
    if (!file) { return; }
    if (!/^image\/(jpe?g|png|webp)$/.test(file.type)) {
      this.eventImageError = 'Image must be a JPG, PNG or WebP file';
      return;
    }
    if (file.size > 4 * 1024 * 1024) {
      this.eventImageError = 'Image must be 4 MB or smaller';
      return;
    }

    this.originalName = file.name;
    const reader = new FileReader();
    reader.onload = () => {
      this.cropSrc = reader.result as string;
      const img = new Image();
      img.onload = () => {
        this.cropImg = img;
        this.cropZoom = 1;
        this.cropX = 0;
        this.cropY = 0;
        this.cropOpen = true;
      };
      img.src = this.cropSrc;
    };
    reader.readAsDataURL(file);
  }

  /** Smallest scale that still covers the frame - the zoom slider multiplies this. */
  private baseScale(): number {
    if (!this.cropImg) { return 1; }
    return Math.max(this.CROP_W / this.cropImg.naturalWidth, this.CROP_H / this.cropImg.naturalHeight);
  }

  get cropStyle(): any {
    if (!this.cropImg) { return {}; }
    const scale = this.baseScale() * this.cropZoom;
    return {
      width:  this.cropImg.naturalWidth * scale + 'px',
      height: this.cropImg.naturalHeight * scale + 'px',
      transform: 'translate(calc(-50% + ' + this.cropX + 'px), calc(-50% + ' + this.cropY + 'px))',
    };
  }

  /** Keeps the frame fully covered however the image is dragged or zoomed. */
  private clamp() {
    if (!this.cropImg) { return; }
    const scale = this.baseScale() * this.cropZoom;
    const w = this.cropImg.naturalWidth * scale;
    const h = this.cropImg.naturalHeight * scale;
    const maxX = Math.max(0, (w - this.CROP_W) / 2);
    const maxY = Math.max(0, (h - this.CROP_H) / 2);
    this.cropX = Math.min(maxX, Math.max(-maxX, this.cropX));
    this.cropY = Math.min(maxY, Math.max(-maxY, this.cropY));
  }

  cropZoomChange(value: any) {
    this.cropZoom = Number(value) || 1;
    this.clamp();
  }

  cropDragStart(ev: MouseEvent) {
    this.dragging = true;
    this.dragStartX = ev.clientX - this.cropX;
    this.dragStartY = ev.clientY - this.cropY;
    ev.preventDefault();
  }

  cropDragMove(ev: MouseEvent) {
    if (!this.dragging) { return; }
    this.cropX = ev.clientX - this.dragStartX;
    this.cropY = ev.clientY - this.dragStartY;
    this.clamp();
  }

  cropDragEnd() { this.dragging = false; }

  cropCancel() {
    this.cropOpen = false;
    this.cropSrc = null;
    this.cropImg = null;
  }

  cropApply() {
    if (!this.cropImg) { return; }
    const canvas = document.createElement('canvas');
    canvas.width  = this.CROP_W * this.OUT_SCALE;
    canvas.height = this.CROP_H * this.OUT_SCALE;
    const ctx = canvas.getContext('2d');
    if (!ctx) { return; }

    const scale = this.baseScale() * this.cropZoom * this.OUT_SCALE;
    const w = this.cropImg.naturalWidth * scale;
    const h = this.cropImg.naturalHeight * scale;
    // Frame centre minus half the drawn size, shifted by the drag offset.
    const dx = (canvas.width  - w) / 2 + this.cropX * this.OUT_SCALE;
    const dy = (canvas.height - h) / 2 + this.cropY * this.OUT_SCALE;

    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this.cropImg, dx, dy, w, h);

    canvas.toBlob((blob) => {
      if (!blob) { return; }
      const name = this.originalName.replace(/\.[^.]+$/, '') + '-card.jpg';
      this.eventImageFile = new File([blob], name, { type: 'image/jpeg' });
      this.eventImagePreview = canvas.toDataURL('image/jpeg', 0.9);
      this.cropOpen = false;
      this.cropSrc = null;
      this.cropImg = null;
    }, 'image/jpeg', 0.9);
  }

  onSubmit() {
    this.submitted = true;
    const formData = new FormData();
    //let startDate;

    // startDate= this.eventForm.get('eventStartDate').value
    let event_startDate = this.eventForm.get("eventStartDate").value;
    let formatted_start_date =
      event_startDate.getFullYear() +
      "-" +
      (event_startDate.getMonth() + 1) +
      "-" +
      event_startDate.getDate();

    let event_endDate = this.eventForm.get("eventEndDate").value;
    let formatted_end_date =
      event_endDate.getFullYear() +
      "-" +
      (event_endDate.getMonth() + 1) +
      "-" +
      event_endDate.getDate();

    let reporting_date = this.eventForm.get("reportingDate").value;
    let formatted_reporting_date =
      reporting_date instanceof Date
        ? reporting_date.getFullYear() +
          "-" +
          (reporting_date.getMonth() + 1) +
          "-" +
          reporting_date.getDate()
        : "";

    let eventId = this.eventForm.get("eventId").value;
    formData.append("eventName", this.eventForm.get("eventName").value);
    formData.append(
      "registrationCharge",
      this.eventForm.get("registrationCharge").value
    );
    formData.append("eventStartDate", formatted_start_date);
    formData.append("eventEndDate", formatted_end_date);
    formData.append("reportingDate", formatted_reporting_date);
    formData.append("eventLocation", this.eventForm.get("eventLocation").value);
    formData.append("eventType", this.eventForm.get("eventType").value);
    formData.append("eventZone", this.zoneValue);
    formData.append("eventNote", this.eventForm.get("eventNote").value);
    formData.append("eventDesc", this.eventForm.get("eventDesc").value);
    formData.append(
      "certificateHeaderContent",
      this.eventForm.get("certificateHeaderContent").value
    );
    formData.append(
      "certificateMainContent",
      this.eventForm.get("certificateMainContent").value
    );
    formData.append(
      "extraTabRequired",
      this.eventForm.get("extraTabRequired").value
    );
    formData.append("extraTabValues", this.extraFieldsCsv());
    formData.append("contactPhone", this.eventForm.get("contactPhone").value);
    formData.append("contactEmail", this.eventForm.get("contactEmail").value);
    if (this.eventImageFile) {
      formData.append("eventImage", this.eventImageFile, this.eventImageFile.name);
    }
    if (eventId == "") {
      this.eventService.saveEventData(formData).pipe(takeUntil(this.destroy$)).subscribe(
        (res) => {
          if (res.status === "error") {
            this.messageService.add({
              severity: "error",
              summary: "Error Message",
              detail: "Validation failed",
            });
          } else {
            this.messageService.add({
              key: "custom",
              severity: "success",
              summary: "Event Data Added Successfully",
            });
            // this.eventForm.reset();
          }
          this.display = false;
          this.getEventData();
        },
        (error) => (this.error = error)
      );
    } else {
      this.eventService.editEventData(eventId, formData).pipe(takeUntil(this.destroy$)).subscribe(
        (res) => {
          if (res.status === "success") {
            this.messageService.add({
              key: "custom",
              severity: "success",
              summary: "Event Data Updated Successfully",
            });
            //this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});
          } else {
            this.messageService.add({
              key: "custom",
              severity: "success",
              summary: "Event Data Updated Successfully",
            });
          }
          this.display = false;
          this.getEventData();
        },
        (error) => (this.error = error)
      );
    }
  }
  handleChange(e) {
    let isChecked = e.checked;
  }
  deleteEvent(event: Event, eventData: Event) {
    if (event.defaultPrevented) return;
    event.preventDefault();
    this.confirmation.confirm({
      key: "confirm-delete-event",
      icon: "pi pi-info-circle",
      message: "Are you sure to delete event data?",
      accept: () => {
        this.deleteMappedEvent(eventData);
      },
    });
  }

  private _deleteeventInfo() {
    this.messageService.add({
      key: "custom",
      severity: "success",
      summary: "Event Data Deleted Successfully",
    });
  }
  deleteMappedEvent(eventData) {
    let eventId = eventData.eventId;
    this.eventService.deleteEvent(eventId).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        //  if (res.status !== 'error') {
        //    this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});
        //  } else {
        this.messageService.add({
          key: "custom",
          severity: "success",
          summary: "Event Data Deleted Successfully",
        });

        //  }

        this.display = false;
        this.getEventData();
      },
      (error) => (this.error = error)
    );
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
